var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{attrs:{"data":_vm.data}},[_c('el-table-column',{attrs:{"label":"Title","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{attrs:{"href":_vm.url(props.row)}},[_vm._v(_vm._s(props.row.text))])]}}])}),_c('el-table-column',{attrs:{"prop":"score","label":"Frequency","sortable":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }